module.exports = __webpack_public_path__ + "img/sh1.c84ccd58.png";